import { atom } from "jotai";

export type VersioningDialogState = {
	view: "branches" | "settings";
	autoOpenHead?: boolean;
	autoOpenPublish?: boolean;
	autoOpenPublishSettings?: boolean;
} | null;

// IMPORTANT: MUST CAST here to work around a typing bug.
//
// With `strictNullChecks: false`, `null` is assignable to function types, so `atom(null)` matches
// jotai's `atom(read: Function): Atom<T>` (read-only) overload. Casting `null` to
// `VersioningDialogState | null` seems to resolve the issue.
//
// NOTE: `atom<VersioningDialogState | null>` DOES NOT fix the situation. You MUST cast.

export const $versioningDialog = atom<VersioningDialogState>(null as VersioningDialogState | null);
$versioningDialog.debugLabel = "versioningDialog";
